import './SecHeadSignup.css'

const SecHeadSignup = () => {

  return (
    <div className="page-header align-items-start section-height-60 pt-5 pb-0 m-3 border-radius-lg main-header">
      <span className="mask bg-gradient-dark opacity-6"></span>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5 text-center mx-auto">
            <h1 className="text-white mb-2 mt-5">Welcome!</h1>
              <div className="si-bottom text-lead text-white">Sign up using email or crypto wallet.<br/><br/><br/><br/></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SecHeadSignup;
